<template>
    <div>
        <div class="queue-box">
            <p>人数过多，排队中</p>
            <el-progress type="circle" :width="36" :percentage="percentage" :show-text="false"></el-progress>
        </div>
        <div class="lineup">
            <p>您在队列中的位置：<span class="lineup-number">{{queue.number}}</span></p>
            <p>预计等待时间：{{transferTime(queue.time)}}</p>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex'
    export default {
        data () {
            return {
                percentage: 0,
                queue: {
                    number: 0,
                    time: 0
                }
            }
        },
        computed: mapState(['user']),
        created () {
            if (this.user._id) {
                this.isQueueUp();
            }
        },
        methods: {
            ...mapMutations('check', ['setQueue']),
            ...mapActions('check', ['getQueueUp']),
            //是否需要排队
            isQueueUp () {
                return this.getQueueUp().then(res => {
                    this.setQueue(res.isQueue);
                    if (res.isQueue) {
                        let number = this.queue.number;
                        this.queue.number = number > 0 && number < res.queueNum ? number : res.queueNum;
                        this.queue.time = res.queueTime;
                        this.interval();
                    }
                    return res.isQueue;
                })
            },
            interval () {
                if (this.percentage >= 100) {
                    this.percentage = 0;
                    this.isQueueUp();
                    return;
                }
                this.percentage += 4;
                setTimeout(() => {
                    this.interval();
                }, 1000);
            },
            //转换时间
            transferTime (value) {
                let theTime = parseInt(value);// 秒
                let theTime1 = 0;// 分
                let theTime2 = 0;// 小时
                if(theTime > 60) {
                    theTime1 = parseInt(theTime/60);
                    theTime = parseInt(theTime%60);
                    if(theTime1 > 60) {
                        theTime2 = parseInt(theTime1/60);
                        theTime1 = parseInt(theTime1%60);
                    }
                }
                let result = ""+parseInt(theTime)+"秒";
                if(theTime1 > 0) {
                    result = ""+parseInt(theTime1)+"分"+result;
                }
                if(theTime2 > 0) {
                    result = ""+parseInt(theTime2)+"小时"+result;
                }
                return result;
            }
        }
    }
</script>

<style lang="scss">
    /*排队*/
    .queue-box {
        position: relative;
        color: #fff;
        padding: 30px 0;
        background-color: #2573e8;
        border-color: #2573e8;
        border-radius: 4px;
        p {
            margin: 0;
            font-size: 30px;
        }
        .el-progress {
            position: absolute;
            top: 34px;
            right: 30px;
            .el-progress-circle__track {
                stroke: #fff;
            }
            .el-progress-circle__path {
                stroke: #2573e8;
            }
        }
    }
    .lineup {
        width: 100%;
        line-height: 34px;
        padding: 12px;
        border: 1px solid #e1e5e8;
        background-color: #f0f7ff;
        p {
            margin: 0;
        }
        .lineup-number {
            color: #13ce66;
            font-weight: bold;
        }
    }
</style>


// WEBPACK FOOTER //
// app/view/index/components/QueueProgress.vue